export const EVENTS = {
    SWITCH_SIGN_UP: "switch_sign_up",
    SWITCH_SIGN_IN: "switch_sign_in",
    CHANGE_MOBILE : "change_mobile",
    RESEND_OTP : "resend_otp",
    SUBMIT_UPLOAD : "submit_upload",
    SUBMIT_DOCUMENT: "submit_document",
    SUBMIT_PROFILE : "submit_profile",
    SUBMIT_TRAINING : "submit_training",
    SUBMIT_COURSE : "submit_course",
    VIEW_COURSE: "view_course",
    REQUIRE_CONTRACT : "require_contract"
  };
  